const SECOND_MS = 1000;
const MINUTE_MS = 60 * SECOND_MS;

/**
 * The webhook stays the primary signal: the server leaves a pending deposit to it for the first
 * minute and only then starts asking Meld. Polls in that minute are DB-only and still catch a
 * webhook whose Pusher event was missed.
 */
const WEBHOOK_GRACE_MS = MINUTE_MS;
const FAST_POLL_WINDOW_MS = WEBHOOK_GRACE_MS + 3 * MINUTE_MS;
/** Matches ONRAMP_FINALIZING_TIMEOUT_MS: past it the timeout view and the 30-min job take over. */
const POLL_STOP_MS = 15 * MINUTE_MS;

export const PAYMENT_STATUS_FAST_POLL_MS = 5 * SECOND_MS;
export const PAYMENT_STATUS_SLOW_POLL_MS = 30 * SECOND_MS;

/**
 * paymentStatusPollDelayMs returns the delay before the next status poll, given how long the page
 * has been waiting on a payment, or null once polling should stop.
 */
export function paymentStatusPollDelayMs(waitingMs) {
  if (waitingMs < FAST_POLL_WINDOW_MS) return PAYMENT_STATUS_FAST_POLL_MS;
  if (waitingMs < POLL_STOP_MS) return PAYMENT_STATUS_SLOW_POLL_MS;
  return null;
}

/**
 * paymentStatusAction maps one add-funds status poll to what the page does next:
 *  - "advance": go to the balance check (deposit completed, or one we saw pending has resolved)
 *  - "failed":  show the failed view (only while waiting on a payment)
 *  - "pending": a deposit is in flight — lock onto the spinner
 *  - "wait":    nothing to do yet
 */
export function paymentStatusAction(status, { sawPending, waiting }) {
  switch (status) {
    case "completed":
      return "advance";
    case "failed":
      return waiting ? "failed" : "wait";
    case "pending":
      return "pending";
    case "none":
      return sawPending ? "advance" : "wait";
    default:
      return "wait";
  }
}
